export default "__VITE_ASSET__DDf4sZHt__"